import React from 'react';

import {
  useSkillsState,
  useSkillsActions,
} from './SkillsContext';

import { getSkills } from './restApi';

import PageController from '../../Shared/UI/PageController/components/PageController';

const SkillsPageController = () => {
  const state = useSkillsState();
  const { onResponse, onError } = useSkillsActions();

  return (
    <PageController
      pageNumber={state?.pageNumber}
      numberOfPages={state?.numberOfPages}
      goToFirstPage={() => {
        getSkills({
          onResponse,
          onError,
          pageNumber: 1,
        });
      }}
      goToPreviousPage={() => {
        getSkills({
          onResponse,
          onError,
          pageNumber: (state?.pageNumber - 1),
        });
      }}
      goToNextPage={() => {
        getSkills({
          onResponse,
          onError,
          pageNumber: (state?.pageNumber + 1),
        });
      }}
      goToLastPage={() => {
        getSkills({
          onResponse,
          onError,
          pageNumber: state?.numberOfPages,
        });
      }}
    />
  );
};

export default SkillsPageController;
